const linearPreviewHeight = 100;
const circularPreviewHeight = 300;
const bottomPadding = 45;
const paddingLinearEditor = 20;
const paddingOligoEditor = 1;
const minHeightEditorContainer = 300;
const pointerWidth = 2;

const MODULE_HEIGHT = 16.5;
const STEP = 3;
const SLOT_HEIGHT = MODULE_HEIGHT * 2;
const TICK_HEIGHT = MODULE_HEIGHT * 2;
const SEQUENCE_HEIGHT = MODULE_HEIGHT;

export {
    linearPreviewHeight,
    circularPreviewHeight,
    bottomPadding,
    paddingLinearEditor,
    paddingOligoEditor,
    minHeightEditorContainer,
    pointerWidth,

    MODULE_HEIGHT,
    SLOT_HEIGHT,
    TICK_HEIGHT,
    SEQUENCE_HEIGHT,
    STEP
}